import React, { Component} from 'react';
import { Alert } from 'reactstrap';

interface ErrorMessageState {
  visible: boolean,
}

interface ErrorMessageProps {
  title: string;
  debug: string;
  message: string;
}

export default class ErrorMessage extends Component<ErrorMessageProps, ErrorMessageState> { 
  constructor(props: any) {
    super(props)
    this.state = {
      visible: true
    }
  }

  onDismiss = () => this.setState({visible: false});

  render() {
    let debug = null;
    if (this.props.debug) {
      debug = <pre><code>{this.props.debug}</code></pre>;
    }
    return (

      <div>
      <Alert severity="error" isOpen={this.state.visible} toggle={this.onDismiss} color="danger">
        <h4 className="alert-heading">{this.props.title} - {this.props.message}</h4>
        <pre><code>{debug}</code></pre>
      </Alert>
      </div>
    );
  }
}